module.exports = __webpack_public_path__ + "static/img/IMG_20161120_124104.d4f83f18.jpg";